export const ReactBlueprintLogo = () => {
  return <div className="mt-5 text-white text-xl font-bold">react-blueprint</div>;
};
